document.addEventListener("DOMContentLoaded", () => {
  const titles = document.querySelectorAll('.js-aa__accordion-title');
  
  if (titles.length > 0) {
    // 最初のタイトルとコンテンツに対してクラスを追加
    let firstTitle = titles[0];
    let firstContent = firstTitle.nextElementSibling;
    firstTitle.classList.add('is-active');
    firstContent.classList.add('is-open');
  }

  for (let i = 0; i < titles.length; i++) {
    let titleEach = titles[i];
    let content = titleEach.nextElementSibling;

    titleEach.addEventListener('click', () => {
      titleEach.classList.toggle('is-active');
      content.classList.toggle('is-open');
    });
  }
});